export const API_URL = process.env.REACT_APP_API_URL
export const SMARTSHEET_URL = process.env.REACT_APP_SMARTSHEET_DOWNLOAD_URL
export const GTAG = process.env.REACT_APP_GTAG